/* eslint prefer-destructuring: 0 */
/* eslint jsx-a11y/label-has-associated-control: 0 */
/* eslint  jsx-a11y/no-static-element-interactions: 0 */
/* eslint  jsx-a11y/click-events-have-key-events: 0 */
/* eslint  max-len: 0 */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import translationKeys from 'translations/translationKeys';
import {
  deleteFromBetSlip, updateStake,
  clearBetSlip, stepStake,
  calculateGains, calculateOdds,
  applyBonus, calculateTax,
  setRetailBet, setClientBonus,
} from 'redux/configs/betConfigsSlice';
import { resumeBet, showModal } from 'redux/place-bet/resumeBetsSlice';
import { formatCurrency, formatRoundedNumber, getDecimalPlacesFromPrecision } from 'components/helpers/currencyOptions';
import { userObj } from 'components/common/requestBody';
import '../../../../styles/_rightsidebar.scss';
import ShowAlert from 'components/common/ShowAlert';
import Modal from 'components/common/Modal';
import ResetPinComponent from 'components/sessions/ResetPinComponent';
import PropTypes from 'prop-types';
import { getClientBonus } from 'redux/client-bonus/clientBonusSlice';
import { checkFailedBet } from 'redux/place-bet/placeBetsSlice';
import isNativeApp from 'components/helpers/native';
import themeAssets from 'assets/theme-assets';
import { selectPrintersError, selectSaveSuccess, selectStatusError } from 'redux/print-config/printConfigSlice';
import {
  getConversionRate,
  selectConversionRate,
  selectConversionExpiresAt,
  selectConversionLoading,
  selectConversionTargetCurrency,
  selectSecondaryCurrencyConfigs,
} from 'redux/configs/currencyConfigsSlice';
import crossImage from '../../../../assets/images/mathys/svg/x-lg.svg';
import defaultImage from '../../../../assets/images/mathys/png/football.png';
import baseUrls from '../../../../config';
import BetSlipHeader from './BetSlipHeader';
import RetailBonusBetSection from './RetailBonusBetSection';
import ConvertedAmount from '../ConvertedAmount';

const BetSlip = ({ isMobile, toggleBetSlip, closeBetSlip }) => {
  const assets = themeAssets[process.env.REACT_APP_THEME_NAME];
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const { agentId, agentPwd, agentPhone } = useSelector((store) => store.login);
  const { lang } = useSelector((store) => store.language);
  const [toggleBetDetails, setToggleBetDetails] = useState(false);

  const {
    printError, printSuccess, unPrintedTicket, isPrintLoading,
  } = useSelector((store) => store.printTicket);

  const {
    odds, bets, betType, stake, finalWinnings, agentBonus,
    multiple, simple, multipleSimple, exciseTaxConfig, TVA,
    potentialWinnings, potentialWinningsWithBonus, minStake, maxStake, exciseTax, tvaConfig, minEvents,
    alerts, integral, bonus, integralTickets, bettingOptions, simpleTickets, maxSimpleBetStake,
    numIntegralTickets, pick, stakeWithoutTax, bonusPercent, stepValue, validMultiple, multipleIntegral, amountPrecision,
  } = useSelector((store) => store.betSlip);

  const { resumeBetLoading, betStatus, showPreview } = useSelector((store) => store.resumeBets);
  const {
    successfetchTicket, verifyTicketMsg, isTicketLoading, isErrorVerifyTckt,
  } = useSelector((store) => store.ticketData);
  const { showRechargeConfirm, rechargeSuccess, isdepositLoading } = useSelector((store) => store.depositData);
  const { checkWithdrawLoading } = useSelector((store) => store.withdrawalChecked);
  const { accountCreation, accountValidation, resendActivationCode } = useSelector((store) => store.customerAccount);
  const {
    showBonRechargeConfirm, bonRechargeSuccess, errorBonRecharge, isBonRechargeLoading,
  } = useSelector((store) => store.bonRechargeData);
  const { successGetBalance, isbalanceLoading, errorGetBalance } = useSelector((store) => store.balance);
  const { canWithdraw, canNotWithdraw, failedCheckWithdraw } = useSelector((store) => store.withdrawalChecked);
  const {
    isPlaceBetLoading, checkedFailedPlacedBet, failedPlacedBet, success, msg,
  } = useSelector((store) => store.placeBets);
  const { withdrawWithCodeLoading, canPrint, failedwithdrawWithCode } = useSelector((store) => store.withdrawWithCode);
  const {
    ticketPaid, showPayConfirm, failedPayTicket, isPaidLoading,
  } = useSelector((store) => store.ticketPaid);
  const { loadingHistory, histMsg } = useSelector((store) => store.history);
  const {
    ticketCanceled, showCancelConfirm, failedCancelTicket, ticketNotRegistered, ticketAlreadyCanceled, isCancelTicketLoading,
  } = useSelector((store) => store.ticketCanceled);
  const {
    resetLoading, resetMessage, resetSuccessMsg, resetPinForm,
  } = useSelector((store) => store.resetPinData);
  const { currencyConfigs } = useSelector((store) => store.currencyConfigs);
  const secondaryCurrencyConfigs = useSelector(selectSecondaryCurrencyConfigs);
  const conversionRate = useSelector(selectConversionRate);
  const conversionExpiresAt = useSelector(selectConversionExpiresAt);
  const conversionLoading = useSelector(selectConversionLoading);
  const conversionTargetCurrency = useSelector(selectConversionTargetCurrency);
  const { customerInfoErrorMsg } = useSelector((store) => store.customerInfo);
  const printersError = useSelector(selectPrintersError);
  const printerStatusError = useSelector(selectStatusError);
  const savePrinterConfigSuccess = useSelector(selectSaveSuccess);

  // ── Secondary currency selection ─────────────────────────────────
  const [selectedTargetCurrency, setSelectedTargetCurrency] = useState(
    () => localStorage.getItem('betslip_target_currency') || null,
  );

  // Auto-select the first secondary currency when none has been chosen yet.
  useEffect(() => {
    if (!selectedTargetCurrency && secondaryCurrencyConfigs?.length > 0) {
      const defaultCurrency = secondaryCurrencyConfigs[0].strCode;
      setSelectedTargetCurrency(defaultCurrency);
      localStorage.setItem('betslip_target_currency', defaultCurrency);
    }
  }, [secondaryCurrencyConfigs, selectedTargetCurrency]);

  // The full config object for the chosen secondary currency (precision,
  // symbol, format rules, etc.) — this is what gets passed to formatCurrency,
  // not a synthetic object built from the primary currencyConfigs.
  const targetCurrencyConfig = (() => {
    if (!secondaryCurrencyConfigs?.length) return null;
    const valid = secondaryCurrencyConfigs.find((c) => c.strCode === selectedTargetCurrency);
    return valid || null;
  })();
  const targetCurrency = targetCurrencyConfig?.strCode || null;

  const handleTargetCurrencyChange = (code) => {
    setSelectedTargetCurrency(code || null);
    if (code) {
      localStorage.setItem('betslip_target_currency', code);
    } else {
      localStorage.removeItem('betslip_target_currency');
    }
  };

  const imgUrl = baseUrls.BASE_URL_IMG;
  const betTypes = (`${bettingOptions}`).split(',');
  const simpleBetIndex = betTypes.lastIndexOf('SIMPLE');
  const multipleBetIndex = betTypes.lastIndexOf('MULTIPLE');
  const multipleSimpleBetIndex = betTypes.lastIndexOf('MULTI_SIMPLE');

  const [retailBetParam, setRetailBetParam] = useState({});
  const [agentBonusParam, setAgentBonusParam] = useState({});
  const [inValidRetailBonus, setInValidRetailBonus] = useState(false);
  const [focusedStakeKey, setFocusedStakeKey] = useState(null);
  const [focusedStakeValue, setFocusedStakeValue] = useState('');

  const location = useLocation();
  const isOnPrinterConfig = location.pathname.includes('printer-config');
  const decimalPlaces = getDecimalPlacesFromPrecision(amountPrecision);

  // ── Helpers ───────────────────────────────────────────────────────
  const switchBetDetails = () => setToggleBetDetails((v) => !v);
  const setStake = (value) => dispatch(updateStake(value));

  const betMinStake = () => {
    if ('value' in agentBonus) return agentBonus.partialStake ? minStake : agentBonus.amount;
    return minStake;
  };

  const betMaxStake = (ticket = null) => {
    if (agentBonus?.value) return agentBonus.amount > maxStake ? maxStake : agentBonus.amount;
    if (simple && !multipleSimple) return maxSimpleBetStake;
    if (ticket !== null) return ticket.maxSimpleBetStake;
    return maxStake;
  };

  const handleStakeFocus = (e) => {
    e.target.select();
    setFocusedStakeKey('stake');
    setFocusedStakeValue(String(bets.length > 0 ? stake : minStake));
  };

  const handleInputPrice = (e) => {
    let value = e.target.value.replace(',', '.');
    if (!/^\d*\.?\d*$/.test(value)) return;
    if (value === '.') value = '0.';
    const [, decimals = ''] = value.split('.');
    if (decimals.length > decimalPlaces) {
      const n = Number.parseFloat(value);
      if (Number.isFinite(n)) value = n;
    }
    setFocusedStakeValue(value);
    setStake(value);
  };

  const handleStakeBlur = () => {
    const n = Number.parseFloat(focusedStakeValue);
    const value = Number.isFinite(n) ? n : Number(betMinStake() || 0);
    setStake(formatRoundedNumber(value, amountPrecision));
    setFocusedStakeKey(null);
  };

  const handleSubInputFocus = (e, inputId, currentStake) => {
    e.target.select();
    setFocusedStakeKey(inputId);
    setFocusedStakeValue(String(currentStake));
  };

  const handleSubInputBlur = (ticketIndex, currentStake) => {
    const n = Number.parseFloat(currentStake);
    const value = Number.isFinite(n) ? n : Number(betMinStake() || 0);
    dispatch(updateStake({ index: ticketIndex, stake: formatRoundedNumber(value, amountPrecision) }));
    setFocusedStakeKey(null);
  };

  const recompute = () => {
    dispatch(calculateOdds());
    dispatch(calculateGains());
    dispatch(applyBonus());
    dispatch(calculateTax());
  };

  const handleSubInputPrice = (e, index) => {
    let value = e.target.value.replace(',', '.');
    if (!/^\d*\.?\d*$/.test(value)) return;
    if (value === '.') value = '0.';
    const [, decimals = ''] = value.split('.');
    if (decimals.length > decimalPlaces) {
      const n = Number.parseFloat(value);
      if (Number.isFinite(n)) value = n;
    }
    setFocusedStakeValue(value);
    setStake({ stake: value, index });
    recompute();
  };

  const setRetailBetInfo = (param) => {
    dispatch(setRetailBet(param));
    setRetailBetParam(param);
    setAgentBonusParam({});
    dispatch(setClientBonus({}));
    setStake(minStake);
  };

  const setAgentBonus = (bonusVal) => {
    setRetailBetParam({});
    dispatch(setRetailBet({}));
    dispatch(setClientBonus(bonusVal));
    if ('value' in bonusVal) {
      setAgentBonusParam({ bonid: bonusVal.value });
      setStake(bonusVal.partialStake ? minStake : bonusVal.amount);
    } else {
      setAgentBonusParam({});
      setStake(minStake);
    }
    recompute();
  };

  const getAgentBonuses = () => {
    if (agentId?.length > 0) dispatch(getClientBonus(agentId));
  };

  const sendResumeBet = () => {
    let ticketValue = 3;
    if (betType === 'SIMPLE') ticketValue = 1;
    else if (betType === 'MULTIPLE') ticketValue = 2;
    else if (betType === 'MULTI_SIMPLE') ticketValue = 5;

    let amt = Number(stake) === 0 ? Number(minStake) : Number(stake);
    if (multipleSimple) {
      amt = [...simpleTickets]
        .map((t) => (Number(t.stake) === 0 ? Number(minStake) : Number(t.stake)))
        .join('S');
    }

    dispatch(resumeBet([{
      lang,
      uid: agentId,
      pwd: agentPwd,
      phn: agentPhone,
      pick,
      amt,
      chl: userObj.chl,
      tkt: ticketValue,
      ref: new Date().getTime(),
      dvr: 0.1,
      imei: userObj.imei,
      dtp: userObj.DT,
      kid: 1,
      vers: userObj.ver,
      ...retailBetParam,
      ...agentBonusParam,
    }]));
    dispatch(showModal());
  };

  // ── Conversion staleness ──────────────────────────────────────────
  const isConversionStale = !targetCurrency ? false : (
    !conversionRate
    || conversionTargetCurrency !== targetCurrency
    || !conversionExpiresAt
    || Date.now() >= conversionExpiresAt
  );

  // ── Validation helpers ────────────────────────────────────────────
  const inValidStake = () => !multipleSimple && (stake < betMinStake() || stake > betMaxStake() || stake % stepValue !== 0);
  const inValidSubStake = (t) => t.stake < betMinStake() || t.stake > betMaxStake(t) || t.stake % stepValue !== 0;
  const validMultipleSimple = () => simpleBetIndex > -1 && multipleBetIndex > -1 && multipleSimpleBetIndex > -1;
  const inValidMultipleSimple = () => multipleSimple && simpleTickets.some((t) => inValidSubStake(t));
  const inValidMultiple = () => !validMultiple && (multiple || (multipleIntegral && integral));
  const inValidBetSlip = () => (
    inValidRetailBonus || inValidStake() || inValidMultiple()
    || bets.length < 1 || inValidMultipleSimple()
    || (!!targetCurrency && (isConversionStale || conversionLoading))
  );
  const canSwitchToMultiple = () => bets.length >= minEvents;

  // ── Effects ───────────────────────────────────────────────────────
  useEffect(() => {
    if (!multipleSimple && !isNativeApp() && bets.length > 0) {
      const timeout = setTimeout(() => inputRef?.current?.focus(), 500);
      return () => clearTimeout(timeout);
    }
    return undefined;
  }, [bets, multipleSimple]);

  useEffect(() => {
    dispatch(calculateOdds());
    dispatch(calculateGains());
    dispatch(applyBonus());
    dispatch(calculateTax());
  }, [stake, bets, integral, betType, dispatch]);

  useEffect(() => {
    if (bets.length > 0 && !checkedFailedPlacedBet) dispatch(checkFailedBet());
  }, [bets, checkedFailedPlacedBet, dispatch]);

  useEffect(() => {
    if (bets.length === 0) { setStake(minStake); setAgentBonusParam({}); setRetailBetParam({}); }
  }, [bets, minStake]);

  useEffect(() => {
    if (!targetCurrency || !currencyConfigs?.strCode) return;
    if (isConversionStale && !conversionLoading) {
      dispatch(getConversionRate({ sourceCurrency: currencyConfigs.strCode, targetCurrency }));
    }
  }, [targetCurrency, currencyConfigs, isConversionStale, conversionLoading, dispatch]);

  useEffect(() => {
    if (!conversionExpiresAt) return undefined;
    const ms = conversionExpiresAt - Date.now();
    if (ms <= 0) return undefined;
    const id = setTimeout(() => {
      if (targetCurrency && currencyConfigs?.strCode) {
        dispatch(getConversionRate({ sourceCurrency: currencyConfigs.strCode, targetCurrency }));
      }
    }, ms);
    return () => clearTimeout(id);
  }, [conversionExpiresAt, targetCurrency, currencyConfigs, dispatch]);

  let color;
  if (betStatus === 'Success!') color = process.env.REACT_APP_SUCCESS_COLOR;
  else if (betStatus === 'Failed!') color = process.env.REACT_APP_DANGER_COLOR;
  else color = isMobile ? 'var(--mobile-bet-btn-txt-color)' : 'var(--primary-txt-color)';

  const {
    msg75, msg76, msg77, msg79, msg145, msg149,
    msg157, msg158, msg162, msg181,
  } = translationKeys;

  // ── Stake input with conversion line below ────────────────────────
  const renderStakeInput = (inputId, stakeValue, onFocus, onChange, onBlur, decr, incr, decrDisabled, incrDisabled, focusKey, focusValue) => (
    <div className="stake-input-block">
      <div className="input-group">
        <button className="btn" type="button" disabled={decrDisabled} onClick={decr}>
          {isMobile
            ? <span className="icon" style={{ maskImage: `url(${assets.dash})` }} />
            : <img src={assets.dash} alt="" />}
        </button>
        {isMobile ? (
          <input
            id={inputId}
            type="text"
            inputMode="decimal"
            placeholder={formatRoundedNumber(bets.length > 0 ? betMinStake() : 0, amountPrecision)}
            className="form-control"
            onFocus={onFocus}
            name={inputId}
            ref={inputId === 'stake' ? inputRef : undefined}
            disabled={bets.length < 1}
            value={focusKey === inputId ? focusValue : formatRoundedNumber(stakeValue, amountPrecision)}
            onChange={onChange}
            onBlur={onBlur}
          />
        ) : (
          <div className="form-label-stake">
            <input
              id={inputId}
              type="text"
              inputMode="decimal"
              placeholder={formatRoundedNumber(bets.length > 0 ? betMinStake() : 0, amountPrecision)}
              className="form-control"
              onFocus={onFocus}
              name={inputId}
              ref={inputId === 'stake' ? inputRef : undefined}
              disabled={bets.length < 1}
              value={focusKey === inputId ? focusValue : formatRoundedNumber(stakeValue, amountPrecision)}
              onChange={onChange}
              onBlur={onBlur}
            />
          </div>
        )}
        <button className="btn" type="button" disabled={incrDisabled} onClick={incr}>
          {isMobile
            ? <span className="icon" style={{ maskImage: `url(${assets.plus})` }} />
            : <img src={assets.plus} alt="" />}
        </button>
      </div>
      {/* Conversion shown directly below the stake input */}
      {targetCurrencyConfig && !isMobile && (
        <div className="stake-conversion">
          <ConvertedAmount
            amount={Number(stakeValue) || 0}
            rate={conversionRate}
            loading={conversionLoading}
            targetCurrencyConfig={targetCurrencyConfig}
          />
        </div>
      )}
    </div>
  );

  // ── Slip body ─────────────────────────────────────────────────────
  const slipBody = () => {
    if ((simple || multiple) && !integral && !multipleSimple) {
      return (
        <ul className="match-list list-unstyled">
          {bets.map((item) => {
            const {
              match, odds, team, market, uniqueId, matchNumber,
            } = item;
            return (
              <li key={uniqueId} className="bet">
                <img src={`${imgUrl}${match?.info?.sport?.icon}` || defaultImage} alt="" />
                <div className="block-left">
                  <div className="match">
                    <span>{`${match?.info?.category?.name} - ${match?.info?.tournament?.name}`}</span>
                    <button type="button" className="btn btn-close" onClick={() => dispatch(deleteFromBetSlip(uniqueId))}>
                      <span className="icon" style={{ maskImage: `url(${crossImage})` }} />
                    </button>
                    <span className="span-2">
                      {match?.info?.teamhome?.name}
                      {' '}
                      -
                      {match?.info?.teamaway?.name}
                    </span>
                  </div>
                  <div className="market">
                    <span>
                      {market}
                      {' '}
                      -
                      {' '}
                      {team}
                    </span>
                    <span>{odds}</span>
                  </div>
                  <div className="number"><span>{matchNumber}</span></div>
                </div>
              </li>
            );
          })}
        </ul>
      );
    }

    return (
      <ul className="ticket-list list-unstyled">
        {integral ? integralTickets.map((integralTicket) => {
          const betIndexes = integralTicket.bets;
          const indexKey = betIndexes.reduce((acc, i) => acc + i.toString(), '');
          return (
            <li className="ticket" key={indexKey}>
              <div className="ctn-events">
                <ul className="match-list list-unstyled">
                  {betIndexes?.length > 0 && bets.length > 0 && betIndexes.map((betIndex) => {
                    const {
                      match, odds, team, market, uniqueId, matchNumber,
                    } = bets[betIndex];
                    return (
                      <li key={`${indexKey}-${uniqueId}`} className="bet">
                        <img src={`${imgUrl}${match?.info?.sport?.icon}` || defaultImage} alt="" />
                        <div className="block-left">
                          <div className="match no-close">
                            <span>{`${match?.info?.category?.name} - ${match?.info?.tournament?.name}`}</span>
                            <span>
                              {match?.info?.teamhome?.name}
                              {' '}
                              -
                              {' '}
                              {match?.info?.teamaway?.name}
                            </span>
                          </div>
                          <div className="market">
                            <span>
                              {market}
                              {' '}
                              -
                              {' '}
                              {team}
                            </span>
                            <span>{odds}</span>
                          </div>
                          <div className="number"><span>{matchNumber}</span></div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="zone-bet">
                <div className="line">
                  <span className="lib">{t(msg157)}</span>
                  <span className="val">{integralTicket.odds}</span>
                </div>
                <div className="line">
                  <span className="lib">{t(msg76)}</span>
                  <span className="val">{inValidStake() ? '-' : formatCurrency(integralTicket.potentialWinnings, currencyConfigs)}</span>
                </div>
                {integralTicket.bonus > 0 && (
                <div className="line">
                  <span className="lib">
                    Bonus(
                    {`${integralTicket.bonusPercent}%`}
                    )
                  </span>
                  <span className="val">{inValidStake() ? '-' : formatCurrency(integralTicket.bonus, currencyConfigs)}</span>
                </div>
                )}
                {integralTicket.bonus > 0 && (
                <div className="line">
                  <span className="lib">{`${t(msg158)} + Bonus(${bonusPercent}%)`}</span>
                  <span className="val">{inValidStake() ? '-' : formatCurrency(integralTicket.potentialWinningsWithBonus, currencyConfigs)}</span>
                </div>
                )}
                {integralTicket.TVA > 0 && (
                <div className="line">
                  <span className="lib">{`${integralTicket.tvaConfig.value}% ${integralTicket.tvaConfig.type}`}</span>
                  <span className="val">{inValidStake() ? '-' : formatCurrency(integralTicket.TVA, currencyConfigs)}</span>
                </div>
                )}
                <div className="line">
                  <span className="lib">{t(msg149)}</span>
                  <span className="val">{inValidStake() ? '-' : formatCurrency(integralTicket.finalWinnings, currencyConfigs)}</span>
                </div>
              </div>
            </li>
          );
        }) : simpleTickets?.length > 0 && bets?.length > 0 && simpleTickets.map((simpleTicket, index) => {
          const {
            match, odds, team, market, uniqueId, matchNumber,
          } = bets[simpleTicket.betIndex];
          return (
            <li className="ticket" key={`simple-ticket-${simpleTicket.betIndex}`}>
              <div className="ctn-events">
                <ul className="match-list list-unstyled">
                  <li key={`${simpleTicket.betIndex}-${uniqueId}`} className="bet">
                    <img src={`${imgUrl}${match?.info?.sport?.icon}` || defaultImage} alt="" />
                    <div className="block-left">
                      <div className="match">
                        <span>{`${match?.info?.category?.name} - ${match?.info?.tournament?.name}`}</span>
                        <button type="button" className="btn btn-close" onClick={() => dispatch(deleteFromBetSlip(uniqueId))} />
                        <span className="span-2">
                          {match?.info?.teamhome?.name}
                          {' '}
                          -
                          {' '}
                          {match?.info?.teamaway?.name}
                        </span>
                      </div>
                      <div className="market">
                        <span>
                          {market}
                          {' '}
                          -
                          {' '}
                          {team}
                        </span>
                        <span>{odds}</span>
                      </div>
                      <div className="number"><span>{matchNumber}</span></div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="zone-bet">
                <div className="line">
                  <span className="lib">{t(msg157)}</span>
                  <span className="val">{simpleTicket.odds}</span>
                </div>
                <div className={isMobile ? 'stake' : 'line'}>
                  {!isMobile && <span className="lib">{t(msg75)}</span>}
                  {isMobile && (
                  <div className="title">
                    <span className="lib">{t(msg75)}</span>
                    <span className="text-bold">x1</span>
                  </div>
                  )}
                  {!isMobile ? (
                    <div className="input-betslip">
                      <div className="input-group d-flex align-items-center justify-content-center">
                        <span className="text-bold">1x</span>
                      </div>
                      {renderStakeInput(
                        `stake-${index}`,
                        simpleTicket.stake,
                        (e) => handleSubInputFocus(e, `stake-${index}`, simpleTicket.stake),
                        (e) => handleSubInputPrice(e, simpleTicket.betIndex),
                        () => handleSubInputBlur(simpleTicket.betIndex, focusedStakeValue),
                        () => { dispatch(stepStake({ increment: false, index: simpleTicket.betIndex })); recompute(); },
                        () => { dispatch(stepStake({ increment: true, index: simpleTicket.betIndex })); recompute(); },
                        simpleTicket.stake <= betMinStake(),
                        simpleTicket.stake >= betMaxStake(simpleTicket),
                        focusedStakeKey,
                        focusedStakeValue,
                      )}
                    </div>
                  ) : (
                    renderStakeInput(
                      `stake-${index}`,
                      simpleTicket.stake,
                      (e) => handleSubInputFocus(e, `stake-${index}`, simpleTicket.stake),
                      (e) => handleSubInputPrice(e, simpleTicket.betIndex),
                      () => handleSubInputBlur(simpleTicket.betIndex, focusedStakeValue),
                      () => { dispatch(stepStake({ increment: false, index: simpleTicket.betIndex })); recompute(); },
                      () => { dispatch(stepStake({ increment: true, index: simpleTicket.betIndex })); recompute(); },
                      simpleTicket.stake <= betMinStake(),
                      simpleTicket.stake >= betMaxStake(simpleTicket),
                      focusedStakeKey,
                      focusedStakeValue,
                    )
                  )}
                </div>
                {simpleTicket.exciseTax > 0 && (
                <div className="line">
                  <span className="lib">{`${simpleTicket.exciseTaxConfig.value}% ${simpleTicket.exciseTaxConfig.type}`}</span>
                  <span className="val">{inValidSubStake(simpleTicket) ? '-' : formatCurrency(simpleTicket.exciseTax, currencyConfigs)}</span>
                </div>
                )}
                {simpleTicket.stakeWithoutTax > 0 && simpleTicket.exciseTax > 0 && (
                <div className="line">
                  <span className="lib">{t(msg145)}</span>
                  <span className="val">{inValidSubStake(simpleTicket) ? '-' : formatCurrency(simpleTicket.stakeWithoutTax, currencyConfigs)}</span>
                </div>
                )}
                <div className="line">
                  <span className="lib">{t(msg76)}</span>
                  <span className="val">{inValidSubStake(simpleTicket) ? '-' : formatCurrency(simpleTicket.potentialWinnings, currencyConfigs)}</span>
                </div>
                {simpleTicket.bonus > 0 && (
                <div className="line">
                  <span className="lib">
                    Bonus(
                    {`${simpleTicket.bonusPercent}%`}
                    )
                  </span>
                  <span className="val">{inValidSubStake(simpleTicket) ? '-' : formatCurrency(simpleTicket.bonus, currencyConfigs)}</span>
                </div>
                )}
                {simpleTicket.bonus > 0 && (
                <div className="line">
                  <span className="lib">{`${t(msg158)} + Bonus(${bonusPercent}%)`}</span>
                  <span className="val">{inValidSubStake(simpleTicket) ? '-' : formatCurrency(simpleTicket.potentialWinningsWithBonus, currencyConfigs)}</span>
                </div>
                )}
                {simpleTicket.TVA > 0 && (
                <div className="line">
                  <span className="lib">{`${simpleTicket.tvaConfig.value}% ${simpleTicket.tvaConfig.type}`}</span>
                  <span className="val">{inValidSubStake(simpleTicket) ? '-' : formatCurrency(simpleTicket.TVA, currencyConfigs)}</span>
                </div>
                )}
                <div className="line">
                  <span className="lib">{t(msg149)}</span>
                  <span className="val">{inValidSubStake(simpleTicket) ? '-' : formatCurrency(simpleTicket.finalWinnings, currencyConfigs)}</span>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <>
      <div className={isMobile ? `betslip ${toggleBetSlip ? 'mobile show' : 'mobile'}` : 'betslip'}>
        <form
          className="betslip-form-main"
          onSubmit={(e) => { e.preventDefault(); sendResumeBet(); }}
        >
          <div className="content">
            <BetSlipHeader
              closeMobileBetSlip={closeBetSlip}
              isMobile={isMobile}
              switchBetType={canSwitchToMultiple()}
              clearBetSlip={() => dispatch(clearBetSlip())}
              betCount={bets.length}
              switchTo={{ multiple: canSwitchToMultiple() && multipleSimple && validMultipleSimple(), simple: multiple && validMultipleSimple() }}
              secondaryCurrencyConfigs={secondaryCurrencyConfigs}
              targetCurrency={targetCurrency}
              onCurrencyChange={handleTargetCurrencyChange}
            />

            <div className="slip-body">
              <div className={`ctn-events${integral ? ' integral' : ''}${multipleSimple ? ' multiple-simple' : ''}`}>
                {slipBody()}
              </div>

              <div className="zone-bet">
                {bets.length > 0 && !isMobile && (
                  <RetailBonusBetSection isMobile={isMobile} setAgentBonus={setAgentBonus} setRetailBetInfo={setRetailBetInfo} disableBet={setInValidRetailBonus} getAgentBonuses={getAgentBonuses} useAgentBonus={multiple} />
                )}

                <div className={isMobile ? `bet-details ${toggleBetDetails ? 'up' : ''}` : 'bet-details'}>
                  {bets.length > 0 && isMobile && (
                    <RetailBonusBetSection isMobile={isMobile} setAgentBonus={setAgentBonus} setRetailBetInfo={setRetailBetInfo} disableBet={setInValidRetailBonus} getAgentBonuses={getAgentBonuses} useAgentBonus={multiple} />
                  )}

                  {(simple || multiple) && (
                    <div className="line">
                      <span className="lib">{t(msg157)}</span>
                      <span className="val">{odds}</span>
                    </div>
                  )}

                  {/* ── Main stake input (desktop) ── */}
                  {(simple || multiple || integral) && !isMobile && (
                    <div className="line">
                      <span className="lib">{t(msg75)}</span>
                      <div className="input-betslip">
                        <div className="input-group d-flex align-items-center justify-content-center">
                          <span className="text-bold">{integral ? `${numIntegralTickets}x` : '1x'}</span>
                        </div>
                        {renderStakeInput(
                          'stake',
                          bets.length > 0 ? stake : minStake,
                          handleStakeFocus,
                          handleInputPrice,
                          handleStakeBlur,
                          () => dispatch(stepStake({ increment: false })),
                          () => dispatch(stepStake({ increment: true })),
                          bets.length < 1 || stake <= betMinStake(),
                          bets.length < 1 || stake >= betMaxStake(),
                          focusedStakeKey,
                          focusedStakeValue,
                        )}
                      </div>
                    </div>
                  )}

                  {exciseTax > 0 && (simple || multiple) && (
                  <div className="line">
                    <span className="lib">{`${exciseTaxConfig.value}% ${exciseTaxConfig.type}`}</span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(exciseTax, currencyConfigs)}</span>
                  </div>
                  )}
                  {stakeWithoutTax > 0 && exciseTax > 0 && (simple || multiple) && (
                  <div className="line">
                    <span className="lib">{t(msg145)}</span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(stakeWithoutTax, currencyConfigs)}</span>
                  </div>
                  )}
                  {(simple || multiple) && (
                  <div className="line">
                    <span className="lib">{t(msg76)}</span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(potentialWinnings, currencyConfigs)}</span>
                  </div>
                  )}
                  {(simple || multiple) && bonus > 0 && (
                  <div className="line">
                    <span className="lib">
                      Bonus(
                      {`${bonusPercent}%`}
                      )
                    </span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(bonus, currencyConfigs)}</span>
                  </div>
                  )}
                  {(simple || multiple) && bonus > 0 && (
                  <div className="line">
                    <span className="lib">{`${t(msg158)} + Bonus(${bonusPercent}%)`}</span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(potentialWinningsWithBonus, currencyConfigs)}</span>
                  </div>
                  )}
                  {(simple || multiple) && TVA > 0 && (
                  <div className="line">
                    <span className="lib">{`${tvaConfig.value}% ${tvaConfig.type}`}</span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(TVA, currencyConfigs)}</span>
                  </div>
                  )}
                  {(simple || multiple) && (
                  <div className="line">
                    <span className="lib">{t(msg149)}</span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(finalWinnings, currencyConfigs)}</span>
                  </div>
                  )}
                  {integral && (
                  <div className="line">
                    <span className="lib">{t(msg162)}</span>
                    <span className="val">{inValidBetSlip() ? '-' : formatCurrency(integralTickets.reduce((acc, t) => acc + t.potentialWinningsWithBonus, 0), currencyConfigs)}</span>
                  </div>
                  )}

                  {/* ── Mise totale block ── */}
                  {(simple || multiple) && (
                    <div className="amt-final">
                      <span>{t(msg77)}</span>
                      <p>{inValidBetSlip() ? '-' : formatCurrency(stake, currencyConfigs)}</p>
                      {targetCurrencyConfig && (
                      <ConvertedAmount
                        amount={Number(stake) || 0}
                        rate={conversionRate}
                        loading={conversionLoading}
                        targetCurrencyConfig={targetCurrencyConfig}
                      />
                      )}
                    </div>
                  )}
                  {integral && (
                    <div className="amt-final">
                      <span>{t(msg77)}</span>
                      <p>{inValidBetSlip() ? '-' : formatCurrency(stake * numIntegralTickets, currencyConfigs)}</p>
                      {targetCurrencyConfig && (
                      <ConvertedAmount
                        amount={Number(stake) * numIntegralTickets || 0}
                        rate={conversionRate}
                        loading={conversionLoading}
                        targetCurrencyConfig={targetCurrencyConfig}
                      />
                      )}
                    </div>
                  )}
                  {multipleSimple && (
                    <div className="amt-final">
                      <span>{t(msg77)}</span>
                      <p>{inValidBetSlip() ? '-' : formatCurrency(simpleTickets.reduce((acc, t) => acc + t.stake, 0), currencyConfigs)}</p>
                      {targetCurrencyConfig && (
                      <ConvertedAmount
                        amount={simpleTickets.reduce((acc, t) => acc + Number(t.stake), 0)}
                        rate={conversionRate}
                        loading={conversionLoading}
                        targetCurrencyConfig={targetCurrencyConfig}
                      />
                      )}
                    </div>
                  )}

                  {alerts.length > 0 && !isMobile && <ShowAlert />}
                </div>

                {/* ── Footer ── */}
                <div className="betslip-footer">
                  {isMobile && bets.length > 0 && (
                    <div className="betslip-menu">
                      {(simple || multiple || integral) && (
                        <div className="stake">
                          <div className="title">
                            <span className="lib">{t(msg75)}</span>
                            <span className="text-bold">{simple || multiple ? 'x1' : `${numIntegralTickets}x`}</span>
                          </div>
                          {renderStakeInput(
                            'stake',
                            bets.length > 0 ? stake : (minStake || 0),
                            handleStakeFocus,
                            handleInputPrice,
                            handleStakeBlur,
                            () => dispatch(stepStake({ increment: false })),
                            () => dispatch(stepStake({ increment: true })),
                            bets.length < 1 || stake <= betMinStake(),
                            bets.length < 1 || stake >= betMaxStake(),
                            focusedStakeKey,
                            focusedStakeValue,
                          )}
                        </div>
                      )}
                      <button className="btn btn-bet-details" type="button" onClick={switchBetDetails}>
                        <span>{msg181}</span>
                        <span className={`icon${toggleBetDetails ? ' rot-180' : ''}`} style={{ maskImage: `url(${assets.arrowDown})` }} />
                      </button>
                    </div>
                  )}

                  {alerts.length > 0 && isMobile && <ShowAlert />}

                  <div className="actions">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ color }}
                      disabled={inValidBetSlip()}
                    >
                      {resumeBetLoading && <span className="spinner-border spinner-border-sm" />}
                      <span className="bold">
                        {t(msg79)}
                        {isMobile && (simple || multiple) && !inValidBetSlip() && ` (${formatCurrency(finalWinnings, currencyConfigs)})`}
                        {isMobile && integral && !inValidBetSlip() && ` (${formatCurrency(integralTickets.reduce((acc, t) => acc + t.potentialWinningsWithBonus, 0), currencyConfigs)})`}
                        {isMobile && multipleSimple && !inValidBetSlip() && ` (${formatCurrency(simpleTickets.reduce((acc, t) => acc + t.finalWinnings, 0), currencyConfigs)})`}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {(showRechargeConfirm || errorGetBalance || canPrint || loadingHistory || histMsg || resumeBetLoading || msg
        || isbalanceLoading || checkWithdrawLoading || isErrorVerifyTckt || isTicketLoading || isCancelTicketLoading
        || accountValidation.isLoading || accountCreation.isLoading || isPlaceBetLoading || isPaidLoading || isdepositLoading
        || isBonRechargeLoading || withdrawWithCodeLoading || verifyTicketMsg || errorBonRecharge || rechargeSuccess || failedCheckWithdraw
        || canWithdraw || canNotWithdraw || bonRechargeSuccess || successGetBalance || showBonRechargeConfirm || failedPayTicket
        || showPayConfirm || showCancelConfirm || ticketPaid || success || showPreview || successfetchTicket || failedwithdrawWithCode
        || ticketCanceled || failedCancelTicket || accountCreation.message.length > 0 || accountValidation.message.length > 0
        || resendActivationCode.message.length > 0 || ticketNotRegistered || ticketAlreadyCanceled || resetLoading
        || resetMessage.length > 0 || resetSuccessMsg.length > 0 || printError || printSuccess || isPrintLoading
        || (failedPlacedBet && bets.length > 0) || (unPrintedTicket && !isOnPrinterConfig)
        || customerInfoErrorMsg.length > 0 || (savePrinterConfigSuccess && !(printersError || printerStatusError))
        || printersError || printerStatusError) && <Modal />}

      {resetPinForm && !isMobile && <ResetPinComponent containerClass="modalContainer" />}
    </>
  );
};

BetSlip.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  toggleBetSlip: PropTypes.bool.isRequired,
  closeBetSlip: PropTypes.func.isRequired,
};

export default BetSlip;
